import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import "./extractgrpupmember.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxesPacking, faChevronDown, faCircleStop, faDownLong, faMagnifyingGlass, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { extractGroupMemberAPI, extractGroupMemberNextAPI, getMembersExtracted, getTheNextInfo } from '../../RTK/Slice/Extract/ExtractGroupMemberSlice'
import { getActiveToken, getId, getPoints, getToken, getUsername } from '../../RTK/Slice/Auth/AuthSlice'
import { Backdrop, Fade, Modal, Skeleton } from '@mui/material'
import { Tooltip } from 'react-tooltip'
import { STATUS } from '../../Constants'
import { CSVLink } from 'react-csv'
import ExtractModal from '../../Components/Utils/ExtractModal' ;
import EgyptPng from "./../../Images/egypt.png" ; 
import IraqPng from "./../../Images/iraq.png" ; 
import UaePng from "./../../Images/uae.png" ; 
import UsaPng from "./../../Images/Flag_of_the_United_States.png" ; 
import yamenPng from "./../../Images/yemen.webp" ; 
import candaPng from "./../../Images/canda.png" ; 
import omanPng from "./../../Images/oman.png" ; 
import libyaPng from "./../../Images/libya.png" ; 
import KuweitPng from "./../../Images/Kuwait.png" ; 
import moroocoPng from "./../../Images/morocco.png" ; 
import qatarPng from "./../../Images/qatar.png" ; 
import algeriaPng from "./../../Images/algeria.png" ; 
import saudiPng from "./../../Images/sauid.png" ; 
import jordonpng from "./../../Images/jordon.png" ; 
import lebnanpng from "./../../Images/lebnan.png" ;
import syria from "./../../Images/syria.png"
import palestine from "./../../Images/palestine.png"
import { extractDataFromDBAPI } from '../../RTK/Slice/Extract/ExtractDataFromDBSlice'
import { toast } from 'react-toastify' ;
import user2 from "./../../Images/user2.png"

const ExtractGroupMemberPage = () => {

    // For Render Choose Country Modal
    const [chooseCountryModal , toogleCountryModal] = useState(false) ;
    
    // For Timer Between Every Request
    const [timer , setTimer ] = useState(0) ;

    let time  = useRef(0) ;

    // For Next btn status
    const [nextBtn , setNextBtn] = useState('con') ; // stop  || con

    // For Control Show Country List
    const [showCountryList , setShowCountryList] = useState(false) ; 

    // For Choose Country state
    const [selectCountry , setSelecCountry] = useState({}) ; // {Country , value}


    const countryModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        height : 250,
        maxWidth : "100%",
        p: 6,
        };

    // For Open Country Modal
    const handleOpenCountryModal = ()=>{
        toogleCountryModal(true) ; 
    }

    // For Access Points 
    const points =  useSelector((state) => state.AdminSlice?.userProfile?.user?.points);

    // For Access Token
    const token = useSelector(getToken) ; 

    // For Get User Name
    const username = useSelector(getUsername) ;

    // For Close Country Modal
    const handleCloseCountryModal = ()=>{
        toogleCountryModal(false)
        setSelecCountry({}) ; 
        setShowCountryList(false) ; 
    }

    // For Control Message Modal
    const [openMessage, setOpenMessage] = useState(false);

    // For Get User ID 
    const userID = useSelector(getId) ; 

    // For Get Data From DB
    const handleExtractOpen = () => {
        if(selectedID.length > 0 && selectCountry.value ){
            if(points >= selectedID.length){
                
                toogleCountryModal(false) ; 
                setOpenExtractModal(true) ; 
                dispatch(extractDataFromDBAPI({token , userId : userID, selectedID , username , db_name : selectCountry.value })) ;
                setSelecCountry({}) ;
            }
            else{
                toast.info("You don't have enough points")
            }

            
        }else{
            toast.info("Please Choose IDs")
        }
    };


    const handleExtractClose = () => setOpenExtractModal(false);

    // For Store Search Input
    const [search , setSearch] = useState('') ; 

    // For store selected IDs
    const [selectedID , setSelectedID] = useState([]) ; 

    // For Store Members 
    const [memberState , setMember ] = useState([]) ;

    // For dispatch action
    const dispatch = useDispatch() ; 

    // For Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        p: 4,
        };
        

    // For Handle Next Btn 
    const handleNexyBtn = ()=>{
        if(nextBtn === 'stop'){
            setNextBtn("con")
        }else{
            setNextBtn("stop")
        }
    }

    // For Access The Next Info
    const {hasNextStatus ,hasNext} = useSelector(getTheNextInfo) ;

   // For Control Extract Modal
    const [openExtractModal, setOpenExtractModal] = useState(false);

    // For Handle Search Value
    const handleSeachField = (e)=>{
        setSearch(e.target.value)
    }

    // For Select Specific Id
    const checkboxHandler = (e)=>{
        console.log(e.target.checked)
        if(e.target.checked)
            setSelectedID(prv => [...prv , e.target.value]) ;
        else 
            setSelectedID(prv => prv.filter(item=> item !== e.target.value ))
    }

    // For Select All IDs
    const selectAllIds = (e)=>{
        if(e.target.checked){
                setSelectedID(members.map(item=>item.id))
        }else{
            setSelectedID([]) ;
        }
    }
    
    // For Access Token FB
    const userToken = useSelector(getActiveToken) ; 

    // For Access Members 
    const {members , statusMember } = useSelector(getMembersExtracted) ; 

    
    // useEffect(()=>{
    //     setMember(members) ;
    // } , [members])

    // For Access Search In DB Data 
    const {data , status } = useSelector(state => state.ExtractDataFromDBSlice) ;     

    // For Render Message Modal
    const renderChoooseCountryModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={chooseCountryModal}
            onClose={handleCloseCountryModal}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={chooseCountryModal}>
                <div className='k-modal my-font' style={countryModalStyle}>

                    <div className='head'>
                        <div className='left'>
                            <h3>Extract Data</h3>
                            <p>Please select the country you want to search in.</p>
                        </div>
                        <div className='right'><FontAwesomeIcon onClick={handleCloseCountryModal} icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>Choose Country </label>

                                <div className='choose-time' onClick={()=>setShowCountryList(!showCountryList)}>
                                <p>{selectCountry.country ? `${selectCountry.country}`: "Country"}</p>
                                <FontAwesomeIcon icon={faChevronDown} />
                                
                                <ul className={`list-items ${showCountryList ? "list-items-show": "" }`}>
                                    {/*<li onClick={()=>setSelecCountry({country : "Egypt" , value : "egy_db"})}  > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt</li>*/}
                                    <li onClick={()=>setSelecCountry({country : "Algeria" , value : "algeria_db"})} ><img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={algeriaPng} alt='flag' /> Algeria</li>
                                    <li onClick={()=>setSelecCountry({country : "Canada" , value : "canada_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={candaPng} alt='flag' /> Canada</li>
                                    <li onClick={()=>setSelecCountry({country : "Egypt" , value : "extra_egy_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt </li>
                                    <li onClick={()=>setSelecCountry({country : "Iraq" , value : "iraq_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={IraqPng} alt='flag' /> Iraq</li>
                                    <li onClick={()=>setSelecCountry({country : "Jordan" , value : "jordan_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={jordonpng} alt='flag' /> Jordan</li>
                                    <li onClick={()=>setSelecCountry({country : "Kuwait" , value : "kuwait_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={KuweitPng} alt='flag' /> Kuwait</li>
                                    <li onClick={()=>setSelecCountry({country : "Lebanon" , value : "lebanon_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={lebnanpng} alt='flag' /> Lebanon </li>
                                    <li onClick={()=>setSelecCountry({country : "Libya" , value : "libya_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={libyaPng} alt='flag' /> Libya</li>
                                    <li onClick={()=>setSelecCountry({country : "Morocco" , value : "morocco_db"})}> <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={moroocoPng} alt='flag' /> Morocco</li>
                                    <li onClick={()=>setSelecCountry({country : "Oman" , value : "oman_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={omanPng} alt='flag' /> Oman</li>
                                    <li onClick={()=>setSelecCountry({country : "Qatar" , value : "qatar_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={qatarPng} alt='flag' /> Qatar</li>
                                    <li onClick={()=>setSelecCountry({country : "Saudi Arabia" , value : "saudi_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={saudiPng} alt='flag' /> Saudi Arabia</li>
                                    <li onClick={()=>setSelecCountry({country : "United Arab Emirates (UAE)" , value : "uae_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UaePng} alt='flag' /> United Arab Emirates (UAE)</li>
                                    <li onClick={()=>setSelecCountry({country : "United States of America (USA)" , value : "usa_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UsaPng} alt='flag' /> United States of America (USA)</li>
                                    <li onClick={()=>setSelecCountry({country : "Yemen" , value : "yemen_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={yamenPng} alt='flag' /> Yemen</li>
                                    <li onClick={()=>setSelecCountry({country : "Syria" , value : "syria_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={syria} alt='flag' /> Syria</li>
                                    <li onClick={()=>setSelecCountry({country : "Palestine" , value : "palestine_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={palestine} alt='flag' /> Palestine</li>
                                </ul>
                                
                                
                            </div>

                        </div>
                    </div>

                    <div className='btn'>
                        <button onClick={handleExtractOpen}>Extract</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }
    
    
    const renderExtractModal = ()=>{
        return( 
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openExtractModal}
            onClose={handleExtractClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >

            <Fade in={openMessage}>
                <ExtractModal closeModal={handleExtractClose} data={data} status={status} />
                
            </Fade>
        </Modal>
    )
    }

    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
        // Convert minutes to milliseconds
        const min = args.t1 * 1000; // 1 minute in milliseconds
        const max = args.t2  * 1000; // 2 minutes in milliseconds
        
        // Generate random number between min and max
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // For Get the next data
    const getNextMembers = useMemo(()=>{
        
        if(hasNext !== null && nextBtn !== 'stop'){
            setTimeout(()=>{
                setTimer( getRandomBetween1And2Minutes({t1 : 10 , t2 : 20}) ) ;
                dispatch(extractGroupMemberNextAPI({userToken , token , groupId :search ,next : hasNext}))
            } , timer)
        }
        else if (hasNext === ""){
            setTimer(0) ;
        }
    } , [hasNext , nextBtn])

    // For handle extract group member submit and call API
    const extractGroupMemberHandler = (e)=>{
        e.preventDefault() ; 
        setTimer(0) ;
        dispatch(extractGroupMemberAPI({userToken , token , groupId : search}))
    }
    
  return (
    <section className='extract-group-member'>
        
        {renderExtractModal()}
        {renderChoooseCountryModal()}
        <div className='main-tools'>
            <form onSubmit={extractGroupMemberHandler} className='search-tools'>
                <div className='search-bar'>
                    <input autoFocus value={search} onChange={handleSeachField} placeholder='Enter Group ID' />
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <button type="submit" className='search-btn-extract btn-hover'>Search</button>
                
                {nextBtn !== 'stop' ?(<button type="button" onClick={handleNexyBtn} className='btn-hover next-btn' >  <FontAwesomeIcon icon={faCircleStop} /> Stop </button>) :<button type="button" onClick={handleNexyBtn} className='btn-hover next-btn' >  <FontAwesomeIcon icon={faPlay} /> Continue </button>}
                <CSVLink filename='Group_Members.csv' style={{color : "gray" , margin :"0px 10px"}} data={members}><span >  <FontAwesomeIcon icon={faDownLong} /></span></CSVLink>
            </form>

            <button onClick={handleOpenCountryModal} className='extract-btn btn-hover'>Extract Data {selectedID.length !== 0 ? `(${selectedID.length})` : ""} <FontAwesomeIcon icon={faBoxesPacking} /> </button>
        </div>

        

        <div className='all-member'>
        <h3> Members extracted : {members.length}</h3>
            <div className='row'>
                <div className='col check'><input onChange={selectAllIds} type="checkbox" /></div>
                <div className='col'> <p className='title-head'>User Profile</p> </div>
                <div className='col'> <p className='title-head'>User ID</p> </div>
                <div className='col'> <p className='title-head'>User Name</p> </div>
            </div>

            {statusMember === STATUS.SUCCESS && hasNextStatus === STATUS.LOADDING && nextBtn === "con" ?
            (
                <Fragment>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive' width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'  width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive' width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'  width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    </Fragment>
            ) :""
        }

            {
                statusMember === STATUS.SUCCESS ? 
                
                members?.map((item)=>{
                    return (
                    <div className='row' key={item.id}>
                        <div className='col check'><input onChange={checkboxHandler} checked={selectedID.includes(item.id)} value={item.id} type="checkbox" /></div>
                        <div className='col'> <img loading='lazy' className='profile-pic' src={item.profilePicture ? item.profilePicture :<img src={user2} alt='default' />} alt='userProfile' /> </div>
                        <div className='col'> <p>{item.id}</p> </div>
                        <div className='col' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item.name}>  <p data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item.name}>{item?.name?.length >100 ?item.name.slice(0 , 80) : item.name}</p> </div>
                    </div>)
                })
                
                :
                ""
            }

            {
                statusMember === STATUS.LOADDING ? (
                    <Fragment>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive' width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'  width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive' width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'  width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    <div className='row'>
                        <div className='col check'> <Skeleton className='load-responsive'  width={50}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                        <div className='col'> <Skeleton className='load-responsive'   width={200}/> </div>
                    </div>
                    </Fragment>
                    
                ) :""
            }
            
            <Tooltip id="my-tooltip" />
        </div>
        

    </section>
  )
}

export default ExtractGroupMemberPage
